import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'

export const PriceAndButton = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
`

export const TextLink = styled.a`
  color: #3586e6;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: unset;
  font-size: 12px;
  width: 130px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  margin: 0 auto;

  ${mediaUp('md')} {
    font-size: 12px;
    width: unset;
  }

  ${mediaUp('lg')} {
    font-size: 16px;
  }
`

export const TreriaryLink = styled.a`
  border-radius: 28px;
  border: 2px solid #3586e6;
  background: #f2f6fd;
  display: flex;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  color: #3586e6;
  font-family: Nunito;
  text-decoration: none;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  font-size: 12px;
  text-align: center;
  cursor: pointer;

  ${mediaUp('md')} {
    font-size: 12px;
    padding: 8px 24px;
  }
  ${mediaUp('lg')} {
    font-size: 16px;
    padding: 12px 28px;
  }
`
